<template>
  <div>
    <edit-study-set-overview
      :studysetDetails="studysetDetails"
      :organizationType="organizationType"
      :organizationId="organizationId"
      :uploadId="uploadId"
      @update:uploadId="$emit('update:uploadId', $event)"
    />
    <api-errors :errors="errors" />
    <study-set-edit-footer
      v-if="!review"
      :cancelActive="true"
      :previousShowIcon="true"
      :primaryAction="createClass"
      :primaryCancelAction="cancelClass"
      :primaryPreviousAction="editClass"
      :primaryPreviousActive="true"
      :primaryPreviousText="$t('study_sets.create_studyset_flow.previous')"
      :primaryText="$t('study_sets.save_changes')"
      :primaryTextShowIcon="false"
    />
    <study-set-edit-footer
      v-else
      :previousShowIcon="false"
      :primaryPreviousActive="false"
      :primaryAction="reviewDone"
      :primaryText="$t('common.done')"
      :primaryTextShowIcon="false"
    />
  </div>
</template>

<script>
import ApiErrors from "@/components/common/ApiErrors";
import EditStudySetOverview from "./EditStudySetOverview";
import StudySetEditFooter from "./StudySetEditFooter";
import { always } from "ramda";
import { mapActions, mapGetters } from "vuex";
import { successMessage } from "@/utils/messages";

export default {
  components: {
    ApiErrors,
    EditStudySetOverview,
    StudySetEditFooter,
  },
  props: {
    studysetDetails: {
      type: Object,
      default: always({ users: [] }),
    },
    currentStep: {
      type: Number,
      default: 2,
    },
    organizationType: {
      type: String,
      default: "",
    },
    uploadId: {
      default: null,
    },
    organizationId: {},
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
    }),
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      errors: {},
      uploadDetails: {},
      primaryLoading: false,
      review: false,
      createdSuccess: false,
    };
  },
  methods: {
    ...mapActions({
      // createStudySetAction: "studysets/createStudySet",
      updateStudySetAction: "readAlouds/updateStudySet",
      updateBuildingStudySet: "studysets/updateBuildingStudySet",
      createWarmUpStudySets: "readAlouds/createWarmUpStudySets",
      setFinalWarmUpStudySets: "readAlouds/setFinalWarmUpStudySets",
    }),
    async createClass() {
      try {
        this.primaryLoading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        
        let phrases = this.studysetDetails.phrases;
        const response = await this.updateStudySetAction(this.studysetDetails);

        // const acceptedPhrases = response.data.phrases;
        this.createdSuccess = true;
        // phrases.forEach((element) => {
        //   if (acceptedPhrases.includes(element.text)) {
        //     element.success = true;
        //   } else {
        //     element.error = true;
        //     this.createdSuccess = false;
        //   }
        // });

        if (this.createdSuccess) {
          this.$emit("last-step");
          successMessage(
            this.$t(
              "study_sets.messages.your_study_set_has_been_updated_successfully"
            ),
            "elsa-message success",
            {
              showClose: false,
            }
          )(this);
        }
        let x = {
          name: response.data.name,
          category: response.data.category,
          shareable: response.data.shareable,
          owner: response.data.owner,
          organization: response.data.organizationId,
          created: true,
          id: response.data.id,
          phrases: phrases,
        };

        this.updateBuildingStudySet(x);
        this.primaryLoading.close();
        this.review = true;
      } catch (error) {
        this.errors = error;
        this.primaryLoading.close();
      }
    },
    reviewDone() {
      return this.$emit("next-step", this.currentStep);
    },
    editClass() {
      this.$emit("edit-step");
    },
    cancelClass() {
      this.$emit("cancel");
    },
    assignToClass() {
      this.$emit("assign-to-class");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

::v-deep .base-create-body {
  margin-top: 35px;
}

::v-deep .base-create-footer {
  margin-top: 24px;
}

::v-deep .generic-error-section {
  margin-bottom: 15px;
}
</style>
